//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Adm.WebControls.SeznamAdmZakazaneHesloDesigner.ts             </Name>
//    <Description>                                                             </Description>
//    <Author>      JKLUSACEK                                                      </Author>
//    <Copyright>   � GORDIC spol. s r. o. 1993-2021                            </Copyright>
//    <Created>     2021-06-10                      </Created>
//  </FileHeader>

//This source code was auto-generated by ADT03-Generator, Version=486.16.5
//AdtGeneratorConfig:[ T:(ginszah) GID:(Web.Set.Des.Ts) V1:(heslo,poznamka,aktivita,dat_zmena,zmenu_prov) V2:() K1:() K2:() K3:() ]


/// <reference path="../../Base/SeznamBase.ts" />

namespace Gordic.Adm.WebControls {

    /**
     * SeznamAdmZakazaneHesloDesigner
     * 
     * @author JKLUSACEK
     * @since 482.1.0.119
     */
    export class SeznamAdmZakazaneHesloDesigner extends SeznamBase {

        /** z detail okna p�edan� atribut pro filtr seznamu */
            /** PK - heslo */
            public heslo: string;

        /** isl view gridu */
        view: Gordic.Isl.View<Gordic.AdmIsl.Interface.GAdmZakazaneHesloListDto>;

        /** vytvo�it formul�� filtru - panel */
        static createFilter(that: GContentType<SeznamAdmZakazaneHesloDesigner>, heslo: string  ): JQuery<HTMLElement> {
            // vytvorim form a na nem policka
            let v_form = this.createFilterForm(that, heslo);
            // vytvorim panel a umistim jej do hlavniho DIVu
            let v_filter = SeznamBase.createFilterBase(that, v_form, true, this.applyAction );

            //v_filter.gfilterpanel("applyFilter");         // toto vede k okam�it�mu na�ten� dat do seznamu podle nastaven�ho filtru

            return (v_filter);
        } // createFilter

        /** vytvo�it formul�� filtru - vytvo�� tam filtra�n� pol��ka */
        static createFilterForm(that: GContentType<SeznamAdmZakazaneHesloDesigner>, heslo: string ): Forms.Form {

            // vytvo��m form
            var v_filterForm = SeznamBase.createFilterFormBase(that);

            // p�id�m do n�j pol��ka

            return v_filterForm;
        } // createFilterForm

        static applyAction(that: GContentType<SeznamAdmZakazaneHesloDesigner>, ev, ctx): any {
            var filterObj = {
            }
            that.view = new Gordic.Isl.View(that.isl.AdmZakazaneHeslo.list({ filters: filterObj }));
            that.grid.ggrid("setData", that.view);
        }

        /**
         * SeznamAdmZakazaneHesloDesignerInit
         * 
         * @param {GContentType<SeznamAdmZakazaneHesloDesigner>} that
         */
        static SeznamAdmZakazaneHesloDesignerInit(that: GContentType<SeznamAdmZakazaneHesloDesigner>, heslo: string ) {

            this.SeznamBaseInit(that);
            that.filter = this.createFilter(that, heslo);

            that.gridFormat = this.createGridFormatByDataListDescription(that);
            that.gridSearchColumns = this.createGridSearchColumnsByDataListDescription(that);

            var filterObj: any = {}
            that.view = new Gordic.Isl.View(that.isl.AdmZakazaneHeslo.list({ filters: filterObj }), { filterPanel: that.filter, startEmpty: false, });       // propojen� ovl�dac�ho prvku gridu se zdrojem dat - a s filter panelem

        } // SeznamAdmZakazaneHesloDesignerInit

    }
}
